import { useParams } from "react-router";
import { BlockForm } from "@/components/blocks/block-form";
import { Id } from "@convex/_generated/dataModel";

export default function EditBlockPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Block not found</p>
      </div>
    );
  }

  const blockId = id as Id<"blocks">;

  return (
    <div className="container mx-auto px-4 py-8 pb-24 sm:pb-8 max-w-lg">
      <BlockForm mode="edit" blockId={blockId} />
    </div>
  );
}
